"use client";

import SearchScreen from "@/components/travel/search-screen";

export default function Home() {
  return <SearchScreen />;
}
